export const stage_categories = {
	ID_FORM_CATEGORY:{
		id:1,
		label:"Form",
		type:'form',
	},
	ID_QUIZ_CATEGORY:{
		id:2,
		label:"Quiz",
		type:'quiz',
	},
	ID_GAME_CATEGORY:{
		id:3,
		label:"Games",
		type:'game',
	},
	ID_ROULETTE_CATEGORY:{
		id:4,
		label:"Roulette",
		type:'roulette',
	},
	ID_TIMED_CATEGORY:{
		id:5,
		label:"Timed",
		type:'timed',
	},
	ID_BRACKET_CATEGORY:{
		id:6,
		label:"Brackets",
		type:'bracket',
	},
	ID_MEDIA_CATEGORY:{
		id:7,
		label:"Media Contest",
		type:'media',
	},
	ID_VOTING_CATEGORY:{
		id:8,
		label:"Voting Gallery",
		type:'media',
	},
	ID_STORY_CATEGORY:{
		id:9,
		label:"Descriptive Content",
		type:'story',
	},
	ID_CRUSH_CATEGORY:{
		id:10,
		label:"Slide & Match",
		type:'crush',
	},
	ID_REVEAL_CATEGORY:{
		id:11,
		label:"Scratch & Win",
		type:'scratch',
	},
	ID_REVEAL_WIN_CATEGORY:{
		id:12,
		label:"Reveal & win",
		type:'scratch',
	},
	ID_GUESSWORD_CATEGORY:{
		id:13,
		label:"Word Shuffle",
		type:'guessword',
	},
	ID_TEAM_CATEGORY:{
		id:14,
		label:"Make your team",
		type:'team',
	},
	ID_SMASHIT_CATEGORY:{
		id:15,
		label:"Tap Tap",
		type:'taptap',
	},
	ID_STACKIT_CATEGORY:{
		id:16,
		label:"The Tower",
		type:'tower',
	},
	ID_CROSSWORDS_CATEGORY:{
		id:17,
		label:"Crossword",
		type:'crossword',
	},
	ID_STAGE_FORM:{
		id:18,
		label:"Form",
		type:'form',
	},
	ID_STAMPSCARD_CATEGORY:{
		id:19,
		label:"Stamp card",
		type:'punchcard',
	},
	ID_CATCHIT_CATEGORY:{
		id:20,
		label:"Falling Objects",
		type:'catchit',
	},
	ID_PHOTO_FUN:{
		id:21,
		label:"Photo Fun",
		type:'photofun',
	},
};

export const visible_stage_categories = {
	ID_GAME_CATEGORY:{
		id:1,
		label:"Games",
		type:'game',
	},
	ID_QUIZ_CATEGORY:{
		id:2,
		label:"Questions and Answers",
		type:'quiz',
	},
	ID_DIRECT_PRIZE_CATEGORY:{
		id:3,
		label:"Direct Prizes",
		type:'direct_prize',
	},
	ID_MEDIA_CATEGORY:{
		id:4,
		label:"Multimedia Content",
		type:'media',
	},
	ID_OTHER_CATEGORY:{
		id:5,
		label:"Other",
		type:'other',
	},
};

export const stage_promotion_types = {
	ENTRY_FORM:{ id:1 },
	KNOWLEDGE_QUIZ:{ id:5 },
	SURVEY:{ id:6 },
	PERSONALITY_QUIZ:{ id:7 },
	PREDICTIONS:{ id:8 },
	COUPON_CODES:{ id:9 },
	PROMOTIONAL_CODE:{ id:10 },
	REDEEM_CODE:{ id:11 },
	INSTANT_WIN:{ id:12 },
	INSTAGRAM_CONTEST:{ id:18 },
	PUZZLE:{ id:21 },
	WORDSEARCH:{ id:22 },
	MEMORY:{ id:23 },
	HIDDEN_OBJECTS:{ id:24 },
	ROULETTE:{ id:25 },
	PRODUCT_RECOMMENDER:{ id:27 },
	MATCH_IT:{ id:28 },
	SCRATCH_WIN:{ id:29 },
	MINESWEEPER:{ id:30 },
	TIMEDQUIZ:{ id:34 },
	BRACKETS:{ id:35 },
	MEDIA_CONTEST:{ id:36 },
	VOTING_CATEGORY:{ id:37 },
	CRUSH:{ id:39 },
	STORY:{ id:40 },
	REVEAL_WIN:{ id:41 },
	GUESS_THE_WORD:{ id:43 },
	TEAM:{ id:44 },
	MEDIA_AUTOCONTENT:{ id:45 },
	SMASHIT:{ id:47 },
	STACKIT:{ id:48 },
	CROSSWORDS:{ id:49 },
	STAGE_FORM:{ id:50 },
	STAMP_CARD:{ id:51 },
	PHOTOFUN:{ id:52 },
	SCENES:{ id:53 },
	CATCHIT:{ id:54 },
	PHOTO_CONTEST:{ id:55 },
	VIDEO_CONTEST:{ id:56 },
	PICK_FAVORITE:{ id:57 },
	LIKEDISLIKE:{ id:59 },
	PUZZLE_NEW:{ id:61 },
	WORDSEARCH_NEW:{ id:62 },
	MEMORY_NEW:{ id:63 },
	HIDDEN_OBJECTS_NEW:{ id:64 },
	MATCH_IT_NEW:{ id:65 },
	MINESWEEPER_NEW:{ id:66 },
	FACEOFF:{ id:67 },
	PENALTY:{ id:68 },
	CANNONBALL:{ id:69 },
	BASKETBALL:{ id:70 },
	SCORE_PREDICTOR:{ id:71 },
	BRACKET_PREDICTOR:{ id:72 },
};

export const getStageTypeLayout = (stage) => {
	const stage_layout = stage_types.find((obj) => { return obj.id == stage.promotion_type_id });
	
	return {
		color_code:stage_layout.color_code,
		icon_class:stage_layout.icon_class,
		name:stage_layout.name,
	}
};

export const stages_with_ranking = [5, 8, 21, 22, 23, 24, 28, 30, 32, 33, 34, 35, 39, 43, 44, 47, 48, 49, 54, 57, 60, 61, 62, 63, 64, 65, 66, 68, 69, 71, 72];
export const stages_with_probability = [25, 29, 41];

export const stage_types = [{
	id:stage_promotion_types.PUZZLE.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-puzzle',
	name:"Puzzle (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.PUZZLE_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-puzzle',
	name:"Puzzle",
	link:'puzzle/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.WORDSEARCH.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-wordsearch',
	name:"Word Search (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.WORDSEARCH_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-wordsearch',
	name:"Word Search",
	link:'wordsearch/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.MEMORY.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-memory',
	name:"Memory (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.MEMORY_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-memory',
	name:"Memory",
	link:'memory/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.CRUSH.id,
	category:stage_categories.ID_CRUSH_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-gem',
	name:"Slide & Match",
	link:'crush/settings',
	completion:true,
	enabled_promo_types:[32, 33, 39, 46, 60],
}, {
	id:stage_promotion_types.GUESS_THE_WORD.id,
	category:stage_categories.ID_GUESSWORD_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-anagram',
	name:"Word Shuffle",
	link:'guessword/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.HIDDEN_OBJECTS.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-search',
	name:"Hidden Objects (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.HIDDEN_OBJECTS_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-search',
	name:"Hidden Objects",
	link:'hidden/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.MATCH_IT.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-match',
	name:"Match It (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.MATCH_IT_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-match',
	name:"Match It",
	link:'matchit/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.SCRATCH_WIN.id,
	category:stage_categories.ID_REVEAL_CATEGORY,
	visible_category:visible_stage_categories.ID_DIRECT_PRIZE_CATEGORY,
	color_code:'',
	icon_class:'knk-scratch',
	name:"Scratch & Win",
	link:'scratch/cover',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.MINESWEEPER.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-bomb',
	name:"Minesweeper (deprecated)",
	link:'questions',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.MINESWEEPER_NEW.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-bomb',
	name:"Minesweeper",
	link:'minesweeper/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.TIMEDQUIZ.id,
	category:stage_categories.ID_TIMED_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-timed-quiz',
	name:"Quiz with Timer",
	link:'trivia/questions',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.ROULETTE.id,
	category:stage_categories.ID_ROULETTE_CATEGORY,
	visible_category:visible_stage_categories.ID_DIRECT_PRIZE_CATEGORY,
	color_code:'',
	icon_class:'knk-roulette',
	name:"Spin the Wheel",
	link:'roulette',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.ENTRY_FORM.id,
	category:stage_categories.ID_FORM_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-breadcrumbs',
	name:"Check in",
	link:'direct',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.STORY.id,
	category:stage_categories.ID_STORY_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-picture-portrait',
	name:"Descriptive Content",
	link:'story',
	enforce_display:true,	// show it even though it has "is_debug = 1" in fb_promotion_types
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.COUPON_CODES.id,
	category:stage_categories.ID_FORM_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-promotional-code',
	name:"Distribute Coupon Codes",
	link:'direct',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.PROMOTIONAL_CODE.id,
	category:stage_categories.ID_FORM_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-promotional-code',
	name:"Promotional code",
	link:'direct',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.REDEEM_CODE.id,
	category:stage_categories.ID_FORM_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-redeem-code',
	name:"Redeem Codes",
	link:'direct',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.INSTANT_WIN.id,
	category:stage_categories.ID_FORM_CATEGORY,
	visible_category:visible_stage_categories.ID_DIRECT_PRIZE_CATEGORY,
	color_code:'',
	icon_class:'knk-winners',
	name:"Instant Win",
	link:'direct',
	completion:false,
	enabled_promo_types:[],	// removed from the new stage_selector, but still needed for old promotions using this stage_type
}, {
	id:stage_promotion_types.SURVEY.id,
	category:stage_categories.ID_QUIZ_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-questions',
	name:"Survey",
	link:'questions',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.KNOWLEDGE_QUIZ.id,
	category:stage_categories.ID_QUIZ_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-brain',
	name:"Knowledge Quiz",
	link:'questions',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.PERSONALITY_QUIZ.id,
	category:stage_categories.ID_QUIZ_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-multichoice',
	name:"Personality Quiz",
	link:'questions',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.PRODUCT_RECOMMENDER.id,
	category:stage_categories.ID_QUIZ_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-recommendator',
	name:"Product Recommender",
	link:'questions',
	completion:false,
	enabled_promo_types:[27, 60],
}, {
	id:stage_promotion_types.PREDICTIONS.id,
	category:stage_categories.ID_QUIZ_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-prediction',
	name:"Predictions",
	link:'questions',
	completion:false,
	enabled_promo_types:[31, 32, 33, 46, 60],
}, {
	id:stage_promotion_types.BRACKETS.id,
	category:stage_categories.ID_BRACKET_CATEGORY,
	color_code:'',
	icon_class:'knk-brackets',
	name:"Brackets",
	link:'brackets',
	completion:false,
	enabled_promo_types:[35, 60],
}, {
	id:stage_promotion_types.TEAM.id,
	category:stage_categories.ID_TEAM_CATEGORY,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-football-team-shirt',
	name:"Build your team",
	link:'team/settings',
	completion:false,
	enabled_promo_types:[31, 32, 60],
}, {
	id:stage_promotion_types.MEDIA_CONTEST.id,
	category:stage_categories.ID_MEDIA_CATEGORY,
	visible_category:visible_stage_categories.ID_MEDIA_CATEGORY,
	color_code:'',
	icon_class:'knk-upload',
	name:"User Generated Content",
	link:'media/main',
	completion:false,
	enabled_promo_types:[32, 33, 36, 45, 53, 55, 56, 58, 60],
}, {
	id:stage_promotion_types.VOTING_CATEGORY.id,
	category:stage_categories.ID_MEDIA_CATEGORY,
	visible_category:visible_stage_categories.ID_MEDIA_CATEGORY,
	color_code:'',
	icon_class:'knk-quiz',
	name:"Voting gallery",
	link:'gallery',
	enforce_display:true,	// show it even though it has "is_debug = 1" in fb_promotion_types
	completion:false,
	enabled_promo_types:[32, 33, 36, 45, 52, 53, 55, 56, 58, 60],
}, {
	id:stage_promotion_types.REVEAL_WIN.id,
	category:stage_categories.ID_REVEAL_WIN_CATEGORY,
	visible_category:visible_stage_categories.ID_DIRECT_PRIZE_CATEGORY,
	color_code:'',
	icon_class:'knk-chest',
	name:"Reveal & Win",
	link:'reveal',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.MEDIA_AUTOCONTENT.id,
	category:stage_categories.ID_MEDIA_CATEGORY,
	visible_category:visible_stage_categories.ID_MEDIA_CATEGORY,
	color_code:'',
	icon_class:'knk-upload',
	name:"Submit Multimedia Content from Administrator",
	link:'media/main',
	completion:false,
	enabled_promo_types:[],	// can't create this type of stage from stage_types selector, but this type of stage needs to be defined so it doesn't break when mirroring it from a Voting gallery
}, {
	id:stage_promotion_types.SMASHIT.id,
	category:stage_categories.ID_SMASHIT_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-whac-a-mole',
	name:"Tap Tap",
	link:'taptap/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.STACKIT.id,
	category:stage_categories.ID_STACKIT_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-stack-it',
	name:"The Tower",
	link:'tower/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.CROSSWORDS.id,
	category:stage_categories.ID_CROSSWORDS_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-crosswords',
	name:"Crossword",
	link:'crosswords/words',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60],
	//hide:true,
}, {
	id:stage_promotion_types.CATCHIT.id,
	category:stage_categories.ID_CATCHIT_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-catch-it',
	name:"Falling Objects",
	link:'falling/settings',
	completion:true,
	enabled_promo_types:[32, 33, 46, 54, 60],
	//hide:true,
},{
	id:stage_promotion_types.STAMP_CARD.id,
	category:stage_categories.ID_STAMPSCARD_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-punch-card',
	name:"Stamp Card",
	link:'stamps/settings',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
	//hide:true,
}, {
	id:stage_promotion_types.STAGE_FORM.id,
	category:stage_categories.ID_STAGE_FORM,
	visible_category:visible_stage_categories.ID_OTHER_CATEGORY,
	color_code:'',
	icon_class:'knk-list',
	name:"Form",
	link:'form/settings',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
	//hide:true,
}, {
	id:stage_promotion_types.PHOTOFUN.id,
	category:stage_categories.ID_PHOTO_FUN,
	visible_category:visible_stage_categories.ID_MEDIA_CATEGORY,
	color_code:'',
	icon_class:'knk-sticker',
	name:"PhotoFun",
	link:'photofun/settings',
	completion:false,
	enabled_promo_types:[32, 33, 46, 52, 53, 60],
	//hide:true,
}, {
	id:stage_promotion_types.SCENES.id,
	category:stage_categories.ID_PHOTO_FUN,
	visible_category:visible_stage_categories.ID_MEDIA_CATEGORY,
	color_code:'',
	icon_class:'knk-scene',
	name:"Scenes",
	link:'scenes/frames',
	completion:false,
	enabled_promo_types:[32, 33, 46, 52, 53, 60],
	//hide:true,
}, {
	id:stage_promotion_types.PICK_FAVORITE.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-pick-favorite',
	name:"Pick Your Favorite",
	link:'pick_favorite/settings',
	key_stats:'pick_favorite',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.LIKEDISLIKE.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-like-dislike',
	name:"Like or Not",
	link:'likedislike/settings',
	key_stats:'like_dislike',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.FACEOFF.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-face-off',
	name:"Face Off",
	link:'battle/settings',
	key_stats:'faceoff',
	completion:false,
	enabled_promo_types:[32, 33, 46, 60],
}, {
	id:stage_promotion_types.PENALTY.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-football-ball',
	name:"Free Kick",
	link:'penalty/settings',
	key_stats:'penalty',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60, 68],
}, {
	id:stage_promotion_types.CANNONBALL.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-balloons',
	name:"Pop it",
	link:'cannonball/settings',
	key_stats:'cannonball',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60, 68],
	hide:true,
}, {
	id:stage_promotion_types.BASKETBALL.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_GAME_CATEGORY,
	color_code:'',
	icon_class:'knk-basketball-ball',
	name:"Basketball",
	link:'basketball/settings',
	key_stats:'basketball',
	completion:true,
	enabled_promo_types:[32, 33, 46, 60, 68],
	hide:true,
}, {
	id:stage_promotion_types.SCORE_PREDICTOR.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-guess-score',
	name:"Score Predictor",
	link:'score_predictor/matches',
	key_stats:'guess_score',
	completion:false,
	enabled_promo_types:[31, 32, 33, 46, 60, 71],
}, {
	id:stage_promotion_types.BRACKET_PREDICTOR.id,
	category:stage_categories.ID_GAME_CATEGORY,
	visible_category:visible_stage_categories.ID_QUIZ_CATEGORY,
	color_code:'',
	icon_class:'knk-brackets',
	name:"Bracket Predictor",
	link:'bracket_predictor/matches',
	key_stats:'bracket_predictor',
	completion:false,
	enabled_promo_types:[31,32, 33, 46, 60, 72],
}];

export const gameWithoutGamePlays = (id, with_score) => {//Sense Gameplays, parametr with score 
	if(with_score == undefined)with_score = false;
	const game_without_score = [
		stage_promotion_types.PICK_FAVORITE.id,// =>hem afegit opcio de punts pero no de punts de JOC
		stage_promotion_types.LIKEDISLIKE.id,
		stage_promotion_types.FACEOFF.id,
		stage_promotion_types.SCORE_PREDICTOR.id,// =>hem afegit opcio de punts pero no de punts de JOC
		stage_promotion_types.BRACKET_PREDICTOR.id,// =>hem afegit opcio de punts pero no de punts de JOC
	];

	if(with_score){
		const index_pick = game_without_score.indexOf(stage_promotion_types.PICK_FAVORITE.id);
		game_without_score.splice(index_pick, 1);
		const index_pred = game_without_score.indexOf(stage_promotion_types.SCORE_PREDICTOR.id);
		game_without_score.splice(index_pred, 1);
		const index_brack = game_without_score.indexOf(stage_promotion_types.BRACKET_PREDICTOR.id);
		game_without_score.splice(index_brack, 1);
	}
	return game_without_score.map(String).includes(String(id));
}

export const multiStageWithoutScore = (id) => {
	const multistage_without_score = [
		stage_promotion_types.MEDIA_CONTEST.id,//NO existeix com a tal
		stage_promotion_types.VOTING_CATEGORY.id,//NO existeix com a tal
		stage_promotion_types.MEDIA_AUTOCONTENT.id,
		stage_promotion_types.PHOTOFUN.id,
		stage_promotion_types.SCENES.id,
		stage_promotion_types.PHOTO_CONTEST.id,
		stage_promotion_types.VIDEO_CONTEST.id,
	];
	return multistage_without_score.map(String).includes(String(id));
}

export const with_score = (id) => {
	let has_score = false;
	let stage = stage_types.find((st) => st.id == id);
	const with_score = [
		stage_categories.ID_QUIZ_CATEGORY.id,
		stage_categories.ID_GAME_CATEGORY.id,
		//stage_categories.ID_ROULETTE_CATEGORY.id,
		stage_categories.ID_BRACKET_CATEGORY.id,
		stage_categories.ID_TIMED_CATEGORY.id,
		stage_categories.ID_CRUSH_CATEGORY.id,
		stage_categories.ID_GUESSWORD_CATEGORY.id,
		stage_categories.ID_TEAM_CATEGORY.id,
		stage_categories.ID_SMASHIT_CATEGORY.id,
		stage_categories.ID_STACKIT_CATEGORY.id,
		stage_categories.ID_CROSSWORDS_CATEGORY.id,
		stage_categories.ID_CATCHIT_CATEGORY.id,
	];

	//if ([stage_promotion_types.SCORE_PREDICTOR.id].includes(stage.id)) return true; 
	const category_id = stage?.category?.id ?? null; 
	if((with_score.map(String).includes(String(category_id)) || isMultiStage(id)) && !multiStageWithoutScore(id) && !gameWithoutGamePlays(id,true)) has_score = true;
	return has_score;
}


//Only for Promotions
export const isMultiStage = (promotion) => {//promotion.promotion_type_id
	let promotion_type_id = null;
	if(typeof promotion === 'object' && promotion.promotion_type_id != undefined) promotion_type_id = promotion.promotion_type_id;
	if(!promotion_type_id)promotion_type_id = promotion; //Per antics casos, promotion es el promotion_type_id directament

	const _promotion_types = [31, 32, 33, 35, 36, 42, 45, 46, 52, 53, 55, 56, 58, 60];
	return _promotion_types.map(String).includes(String(promotion_type_id));
}

export const isStageOpen = (stage,promotion) => {

	const stage_start_date = (!isMultiStage(promotion.promotion_type_id)) ? promotion.start_entry : stage.start_date;
	const stage_end_date = (!isMultiStage(promotion.promotion_type_id)) ? promotion.end_entry : stage.end_date;

	const started = EPDateAfter(null, stage_start_date);
	const ended = EPDateBefore(stage_end_date);

	return started && !ended;
}